module.exports = __webpack_public_path__ + "img/101_pano-min.58cb230b.jpg";